import { BREAKPOINTS } from "@/settings";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "usehooks-ts";

import { BaseLandingPage } from "./BaseLandingPage/BaseLandingPage";
import { USPType } from "./BaseLandingPage/USP";

const saveTimeIcon = (
  <svg
    width="24"
    height="32"
    viewBox="0 0 24 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.1456 27H17.7488C18.9679 27 19.6965 26.331 19.6965 25.0406V24.7295C19.7087 21.4312 16.1957 18.7543 14.6539 17.2966C14.2235 16.8902 13.9966 16.5201 13.9966 15.9822C13.9966 15.4442 14.2235 15.0858 14.6544 14.6677C16.184 13.1855 19.697 10.6764 19.697 7.2465V6.95995C19.697 5.66895 18.9679 5 17.7493 5H6.14509C4.94995 5 4.29272 5.66895 4.29272 6.85237V7.2465C4.29272 10.6764 7.80575 13.1855 9.34761 14.6677C9.77794 15.0858 10.0048 15.4442 10.0048 15.9822C10.0048 16.5201 9.77794 16.8902 9.3471 17.2966C7.80575 18.7548 4.29272 21.4317 4.29272 24.7295V25.1476C4.29272 26.3305 4.95046 27 6.1456 27ZM7.38765 25.3633C6.81405 25.3633 6.63508 24.7295 7.19645 24.3114L11.2836 21.2639C11.4151 21.1569 11.4865 21.085 11.4865 20.9055V15.1577C11.4865 14.5122 11.355 14.1894 10.9012 13.807C10.22 13.2334 8.92951 12.3253 8.34367 11.5009C8.10453 11.1664 8.1285 10.8916 8.42728 10.8916H15.5614C15.8602 10.8916 15.8842 11.1664 15.645 11.5009C15.0597 12.3253 13.781 13.2334 13.088 13.807C12.6342 14.1894 12.5022 14.5122 12.5022 15.1577V20.905C12.5022 21.0845 12.5741 21.1558 12.7056 21.2634L16.8045 24.3109C17.3659 24.729 17.1747 25.3623 16.6133 25.3623L7.38765 25.3633Z"
      fill="#D4D8DE"
    />
  </svg>
);

const saveCoinsIcon = (
  <svg
    width="28"
    height="24"
    viewBox="0 0 28 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 22.5C23.299 22.5 28 17.799 28 12C28 6.20101 23.299 1.5 17.5 1.5C17.2805 1.5 17.0625 1.50674 16.8464 1.52001C20.3855 3.66779 22.75 7.55776 22.75 12C22.75 16.4422 20.3855 20.3322 16.8464 22.48C17.0626 22.4933 17.2805 22.5 17.5 22.5Z"
      fill="#D4D8DE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 12C0 17.799 4.70101 22.5 10.5 22.5C11.7272 22.5 12.9053 22.2895 14 21.9025C18.0782 20.4611 21 16.5718 21 12C21 7.42824 18.0782 3.5389 14 2.09747C12.9053 1.71054 11.7272 1.5 10.5 1.5C4.70101 1.5 0 6.20101 0 12ZM5.42057 7.91638L1.54991 14.5518L2.69834 16.0831H7.12291L10.8943 9.61777L9.84513 7.91638L5.97447 14.5518H3.59157L7.46223 7.91638H5.42057ZM12.2261 7.91638L11.2336 9.61777H13.9559L10.1845 16.0831H12.2261L15.9975 9.61777L18.0392 9.61777L19.0317 7.91638H12.2261Z"
      fill="#D4D8DE"
    />
  </svg>
);

const sbcSolverIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7296 3.62777C17.0897 4.98925 17.6984 2.43635 18.2699 1.84214C19.3227 0.747506 21.1238 0.730108 22.1975 1.8042C23.2713 2.8783 23.2533 4.67936 22.1583 5.73178C21.5553 6.31131 20.3454 6.29345 20.0911 7.19457C19.6655 8.70318 22.2748 9.71647 22.7998 10.9838C23.0667 11.6283 23.0667 12.3721 22.7998 13.0166C22.3494 14.1038 21.1803 14.9219 20.3724 15.7298C19.0123 17.0913 18.4036 14.5384 17.8321 13.9442C17.1543 13.2394 16.1009 12.9425 15.1548 13.1896C13.6854 13.5733 12.7902 15.1362 13.2027 16.5979C13.4683 17.5389 14.2573 18.2973 15.2081 18.5254C17.7733 19.1393 13.8365 22.4603 13.0164 22.8C10.1849 23.9729 9.34262 19.4849 7.19328 20.0913C6.29227 20.3455 6.30981 21.5555 5.73007 22.1582C4.67729 23.2529 2.87622 23.2703 1.80248 22.1962C0.311006 20.7042 1.05468 18.0691 3.10609 17.577C5.7428 16.946 1.48519 13.7045 1.20022 13.0166C0.933261 12.3721 0.933261 11.6283 1.20022 10.9838C1.53997 10.1636 4.86203 6.22704 5.4759 8.79204C5.83065 10.2688 7.37569 11.1945 8.84517 10.8108C10.8863 10.2778 11.5772 7.62842 10.0562 6.16654C9.45326 5.58702 8.24332 5.60488 7.98908 4.70376C7.44297 2.76817 11.3141 0.495262 13.0164 1.2004C14.1036 1.65075 14.9217 2.81987 15.7296 3.62777Z"
      fill="#D9D9D9"
    />
  </svg>
);

const USPs: USPType[] = [
  {
    icon: saveTimeIcon,
    title: "Save time",
    description: (
      <div className="w-76 mobile:w-100">
        Solve SBCs faster with your own club. No more wasting time.
      </div>
    ),
  },
  {
    icon: saveCoinsIcon,
    title: "Save coins",
    description: (
      <div className="w-76 mobile:w-100">
        Save coins by prioritizing untradeable, SBC storage, duplicate players
        and much more.
      </div>
    ),
  },
  {
    icon: sbcSolverIcon,
    title: "Premium Solver",
    description: (
      <div className="w-76 mobile:w-100">
        Get access to the best SBC solver on the market.
      </div>
    ),
  },
];

export const SBCSolverLandingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <BaseLandingPage
      heroTitle="EA FC 25 SBC Solver"
      pageTitle="Solve SBCs with your own club"
      navigateBack={
        (location.state as { from?: string } | null)?.from
          ? (location.state as { from?: string } | null)?.from
          : "/my-club"
      }
      ctaTitle="Subscribe Now"
      USPs={USPs}
      onHandleCTA={() => {
        navigate("/subscription");
      }}
    >
      <img
        src={
          import.meta.env.VITE_APP_ASSETS_BASE_URL +
          "/fc25/banners/myclubbanner/myclubbannermobile2.png"
        }
        className="absolute top-24 touch-device:top-32 touch-device:translate-x-24 large-desktop:translate-x-0 right-0 hidden mobile:block max-w-96 touch-device:max-w-200 large-desktop:max-w-242"
      />
    </BaseLandingPage>
  );
};
